export const supLevels = ['Nedideli', 'Vidutiniai', 'Dideli', 'Labai dideli'];

export const supGroups = ['Negalios', 'Sutrikimai', 'Mokymosi sunkumai'];

// supDisability
export const supDisabilityTypes = [
  'Intelekto sutrikimai',
  'Regos sutrikimai',
  'Klausos sutrikimai',
  'Kochleariniai implantai',
  'Judesio ir padėties sutrikimai',
  'Įvairiapusiai raidos sutrikimai',
  'Kurčneregystė',
  'Kompleksinė negalia',
];

export const supDisabilityIntelect = [
  'Nežymus intelekto sutrikimai',
  'Vidutinis intelekto sutrikimai',
  'Žymus intelekto sutrikimai',
  'Labai žymus intelekto sutrikimai',
  'Nepatikslintas intelekto sutrikimai',
];

export const supDisabilitySight = [
  'Vidutinė silpnaregystė',
  'Žymi silpnaregystė',
  'Aklumas su regėjimo likučiu',
  'Praktiškas aklumas',
  'Visiškas aklumas',
  'Kiti regėjimo sutrikimai',
];

export const supDisabilityHearing = [
  'Nežymus klausos sutrikimai',
  'Vidutinis klausos sutrikimai',
  'Žymus klausos sutrikimai',
  'Labai žymus klausos sutrikimai',
  'Gilus klausos sutrikimai (kurtumas)',
];

export const supDisabilityMovement = [
  'Lengvi judesio ir padėties sutrikimai',
  'Vidutiniai judesio ir padėties sutrikimai',
  'Sunkūs judesio ir padėties sutrikimai',
  'Lėtiniai neurologiniai sutrikimai',
];

export const supDisabilityDevelopment = [
  'Vaikystės autizmas',
  'Atipiškas (netipiškas) autizmas',
  'Rett‘o sindromas',
  'Asperger‘io sindromas',
  'Kiti įvairiapusiai raidos sutrikimai',
];

// supDisorder
export const supComplexDisorders = 'Kompleksinis sutrikimas';
export const supDisorderTypes = [
  'Mokymosi sutrikimai',
  'Elgesio ar / ir emocijų sutrikimai',
  'Kalbėjimo ir kalbos sutrikimai',
  supComplexDisorders,
];

export const supDisorderLearningDisability = [
  'Bendrieji sutrikimai',
  'Specifiniai mokymosi sutrikimai',
  'Neverbaliniai mokymosi sutrikimai',
];

export const supDisorderBehaviouralEmotional = [
  'Aktyvumo ar/ir dėmesio sutrikimai',
  'Elgesio sutrikimai',
  'Emocijų sutrikimai',
];

export const supDisorderSpeech = ['Kalbėjimo sutrikimai', 'Kalbos sutrikimai'];

// SUP LearningDifficulty
export const supLearningDifficultyTypes = [
  'Besimokantys ne gimtąja kalba arba gyvenantys kitoje kultūrinėje / kalbinėje aplinkoje',
  'Sulėtėjusi raida',
  'Sveikatos problemos',
  'Nepalankūs aplinkos veiksniai',
  'Emocinės krizės',
  'Nerealizuoti ypatingi gabumai',
];

// SUP specific sub levels
export const supLearningDisorderSubLevel = [
  'Skaitymo sutrikimai',
  'Rašymo sutrikimai',
  'Matematikos mokymosi sutrikimai',
];

export const supDisorderActivityAndAttentionSubLevel = [
  'Aktyvumo sutrikimas',
  'Dėmesio sutrikimas',
  'Aktyvumo ir dėmesio sutrikimas',
];

export const supDisorderBehaviouralSubLevel = [
  'Prieštaraujančio neklusnumo sutrikimai',
  'Elgesio sutrikimai (asocialus elgesys)',
];

export const subEmotionalDisordersSubLevel = [
  'Nerimo spektro sutrikimai',
  'Nuotaikos spektro sutrikimai',
];
export const supSpeechDisordersSubLevel = [
  'Fonetiniai sutrikimai',
  'Sklandaus kalbėjimo sutrikimai',
  'Balso sutrikimai',
];
export const supLanguageDisordersSubLevel = [
  'Fonologiniai sutrikimai',
  'Kalbos neišsivystymas',
  'Kalbos netekimas',
];
